export default __webpack_public_path__ + "static/media/express.547c44b2.svg";